import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ShipmentSpecialFreightMainInfoState } from './shipment-special-freight-main-info.state';
import { Observable } from 'rxjs';
import {
  ShipmentSpecialFreightOverview,
  ShipmentSpecialFreightOverviewSetInitialState,
} from './shipment-special-freight-main-info.actions';
import { SpecialFreightOverviewModel } from '../../models';
import { SpecialFreightIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentSpecialFreightMainInfoFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentSpecialFreightMainInfoState.getLoaded);
  mainInfo$: Observable<SpecialFreightOverviewModel> = this.store.select(
    ShipmentSpecialFreightMainInfoState.getOverview,
  );

  constructor(private store: Store) {}

  loadAll(identifier: SpecialFreightIdView): void {
    this.store.dispatch(new ShipmentSpecialFreightOverview(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentSpecialFreightOverviewSetInitialState());
  }
}
